import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M4.2 5.655C4.2 4.741 4.941 4 5.855 4h8.69c.914 0 1.655.741 1.655 1.655v7.035c0 .914-.74 1.655-1.655 1.655h-2.172L10.2 16l-2.172-1.655H5.855A1.655 1.655 0 0 1 4.2 12.69V5.655Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);